<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditPromotions</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>

      </div>
      <form [formGroup]="editPromotionForm" *ngIf="PromotionModel" (ngSubmit)="editPromotions()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-6 af-form-group">
                  <label for="typeahead-format" translate>lblSelectDealer
                     </label>
                  <div class='lbl-info'>
                    <input id="typeahead-format" type="text" formControlName="dealer" class="form-control mb-2"
                      placeholder="Search Dealer" [(ngModel)]="PromotionModel.promotionDetails.dealer" name="searchDealer"
                      [ngbTypeahead]="search" [resultFormatter]="formatter" (selectItem)="setDealer($event)" [attr.disabled]="true" />
                    <div *ngIf="cpf.dealer.touched && (cpf.dealer.errors?.required)" class="help-block mt-1 text-danger"
                      translate> <em class="ft-alert-circle align-middle" aria-hidden="true" translate></em>
                      lblDealerNameRequired
                    </div>
                  </div>
                </div>
                <div class="w-100 px-0" *ngIf="p.controls">
                  <div class="col-md-6" *ngFor="let ticket of p.controls; let i = index">
                    <div [formGroup]="ticket">
                      <div class="af-form-group">
                        <label for="promotionNames" translate>lblPromotionName<span> in
                            {{allLanguage[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="name" class="form-control mb-2" required maxlength="50"
                            [ngClass]="{'is-invalid': cpf.promotionNames.invalid}">
                          <div *ngIf="cpf.promotionNames.errors?.required" class="help-block mt-1 text-danger" 
                          translate> <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                            lblPromotionNamesRequired
                          </div>
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 px-0" *ngIf="t.controls">
                  <div class="col-md-6" *ngFor="let ticket of t.controls; let i = index">
                    <div [formGroup]="ticket" class="">
                      <div class="af-form-group">
                        <label for="description" translate>lblPromotionDescription<span> in
                            {{allLanguage[i].value}}</span> </label>
                        <div class='lbl-info'>
                          <input formControlName="description" class="form-control mb-2" required maxlength="200"
                            >
                          
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>lblLanguageId</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="w-100 px-0" *ngIf="c.controls">
                  <div class="col-md-6" *ngFor="let ticket of c.controls; let i = index">
                    <div [formGroup]="ticket">
                      <div class="af-form-group">
                        <label for="categoryNames" translate>lblCategoryName<span> in
                            {{allLanguage[i].value}}</span>
                          <strong class="mlt6 required"> * </strong> </label>
                        <div class='lbl-info'>
                          <input formControlName="name" class="form-control mb-2" required maxlength="200"
                            [ngClass]="{'is-invalid': cpf.categoryNames.invalid}">
                        </div>
                      </div>
                      <div class="af-form-group" style="display: none;">
                        <label for="languageId" translate>Language Id</label>
                        <div class="lbl-info">
                          <input formControlName="languageId" class="form-control mb-2" [ngModel]="allLanguage[i].id"
                            required maxlength="30">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="startDate" translate>lblStartDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                      required [dateTime]="false" placeholder="{{ 'lblEnterStartDate' | translate }}"
                      [disableNextMonthDates]="true" formControlName="startDate" [(ngModel)]="PromotionModel.promotionDetails.startDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="endDate" translate>lblEndDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker" appAfDatepicker [startDate]="'2011/01/01'"
                      placeholder="{{ 'lblEnterEndDate' | translate }}" required [dateTime]="false"
                      [disableNextMonthDates]="true" formControlName="endDate" [(ngModel)]="PromotionModel.promotionDetails.endDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="service" translate>lblOriginalPrice
                     </label>
                  <div class='lbl-info'>
                    <input formControlName="originalPrice" [(ngModel)]="PromotionModel.promotionDetails.originalPrice"
                     class="form-control mb-2" [ngClass]="{'is-invalid': cpf.originalPrice.invalid}" maxlength="50">
                    <div *ngIf="cpf.originalPrice.invalid && (cpf.originalPrice.dirty || cpf.originalPrice.touched)"
                      class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      lblOriginalPriceRequired
                    </div>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="offerStartDate" translate>lblOfferStartDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker width100force" appAfDatepicker [startDate]="'2011/01/01'"
                      required [dateTime]="false" placeholder="{{ 'lblEnterOfferStartDate' | translate }}"
                      [disableNextMonthDates]="true" formControlName="offerStartDate" [(ngModel)]="PromotionModel.promotionDetails.offerStartDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="offerEndDate" translate>lblOfferEndDate
                     </label>
                  <div class='date'>
                    <input class="form-control datePicker" appAfDatepicker [startDate]="'2011/01/01'"
                      placeholder="{{ 'lblOfferEnterEndDate' | translate }}" required [dateTime]="false"
                      [disableNextMonthDates]="true" formControlName="offerEndDate" [(ngModel)]="PromotionModel.promotionDetails.offerEndDate"
                      id="txtboxStartDate" type="text" value="" autocomplete="off">
                    <em class="far fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>
                <div class="col-md-4 af-form-group">
                  <label for="service" translate>lblOfferPrice
                     </label>
                  <div class='lbl-info'>
                    <div class='lbl-info'>
                      <input formControlName="offerPrice" [(ngModel)]="PromotionModel.promotionDetails.offerPrice"
                       class="form-control mb-2" [ngClass]="{'is-invalid': cpf.offerPrice.invalid}" maxlength="50">
                    </div>
                  </div>
                </div>

                <div class="col-md-12 af-form-group">
                  <label for="template-edit-image" translate>lblImage </label>
                  <div class="lbl-info">
                    <div class="border mb-3 p-1 d-inline-block" *ngIf="image">
                      <img af-image [data-code]="PromotionModel.promotionDetails.imagePath" [data-src]="image" id="UploadImage" alt="image does not found." class="carimg">
                    </div>
                    <div class="form-group">
                      <label class="btn btn-outline-primary d-inline-block" for="select-files"
                        translate>lblChangeImage</label>
                      <input type="file" id="select-files" class="" hidden name="image" accept=".png, .jpg, .jpeg"
                        (change)="onChangeFileUpload($event.target.files)">
                    </div>
                  </div>
                </div>
                <div class="col-md-6 af-form-group">
                  <label for="template-edit-image" translate>&nbsp; </label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" [(ngModel)]="PromotionModel.promotionDetails.isActive" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align"
               translate><em
                class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
            <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
                class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>